export const getElementAfter = (arr, target) => {
	const index = arr.indexOf(target);
	return index !== -1 && index < arr.length - 1 ? arr[index + 1] : null;
};

export const parseSearchParams = (search) => {
	if (!search) {
		return {};
	}
	const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
	return Object.fromEntries(params.entries());
};
